define("CCAWBannerCarousel.CCAWBannerCarousel.CCAWBannerCarousel", [
    "CCAWBannerCarousel.CCAWBannerCarousel.CCAWBannerCarousel.View",
], function (CCAWBannerCarouselView) {
    "use strict";

    return {
        mountToApp: function mountToApp(container) {
            // Using the 'Layout' component we add a new child view inside the 'Header' existing view
            // There will be a DOM element with the HTML attribute data-view="Header.Logo"
            // Documentation: https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html

            /** @type {LayoutComponent} */
            var layout = container.getComponent("Layout");

            if (layout) {
                layout.addChildView("CCAW.BannerCarousel.View", function () {
                    return new CCAWBannerCarouselView({ container: container });
                });
            }
        },
    };
});
